import { StyleSheet } from 'react-native';

import { colors, Text } from '@pletly/ui';
import { PASSWORD_MIN_LENGTH } from '@pletly/shared';
import i18n from '../../i18n';

interface Props {
	value?: string;
	size?: 'small' | 'medium';
}

const TEXT_VARIANTS = {
	small: 'c1',
	medium: 's2',
} as const;

export const PasswordRequirementsHint = ({ value = '', size = 'medium' }: Props) => {
	const { t } = i18n;
	const matched = isMeetingRequirements(value);

	return (
		<Text category={TEXT_VARIANTS[size]} style={matched && styles.matched}>
			{t('common.password-requirements-hint', { minLength: PASSWORD_MIN_LENGTH })}
		</Text>
	);
};

const styles = StyleSheet.create({
	matched: {
		color: colors.primary700,
	},
});

const PasswordValidator = {
	hasMinimumCharacters(value: string): boolean {
		return value.length >= PASSWORD_MIN_LENGTH;
	},

	containsNumber(value: string): boolean {
		return /[0-9]/.test(value);
	},

	containsSpecialCharacter(value: string): boolean {
		return /[!#$%&'()*+,-./:;<=>?@[\]^_{|}~]/.test(value);
	},
};
export const isMeetingRequirements = (value: string) => {
	return (
		PasswordValidator.hasMinimumCharacters(value) &&
		PasswordValidator.containsNumber(value) &&
		PasswordValidator.containsSpecialCharacter(value)
	);
};
